"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imColors = void 0;
/* eslint-disable max-lines */
/* eslint-disable sort-keys */

var imColors = exports.imColors = {
  black: '#000000',
  white: '#FFFFFF',
  /** Gray */
  gray25: '#FCFCFD',
  gray50: '#F8FAFC',
  gray100: '#EEF2F6',
  gray200: '#D4DCE7',
  gray300: '#BBC6D3',
  gray400: '#8C96A2',
  gray500: '#697586',
  gray600: '#4B5565',
  gray700: '#364152',
  gray800: '#202939',
  gray900: '#121926',
  gray950: '#0D121C',
  /* Primary */
  primary25: '#F5FAFF',
  primary50: '#EFF8FF',
  primary100: '#D1E9FF',
  primary200: '#B2DDFF',
  primary300: '#84CAFF',
  primary400: '#53B1FD',
  primary500: '#2E90FA',
  primary600: '#1570EF',
  primary700: '#175CD3',
  primary800: '#1849A9',
  primary900: '#194185',
  primary950: '#102A56',
  /** Error */
  error25: '#FFFBFA',
  error50: '#FEF3F2',
  error100: '#FEE4E2',
  error200: '#FECDCA',
  error300: '#FDA29B',
  error400: '#F97066',
  error500: '#F04438',
  error600: '#D92D20',
  error700: '#B42318',
  error800: '#912018',
  error900: '#7A271A',
  error950: '#55160C',
  /** Warning */
  warning25: '#FFFCF5',
  warning50: '#FFFAEB',
  warning100: '#FEF0C7',
  warning200: '#FEDF89',
  warning300: '#FEC84B',
  warning400: '#FDB022',
  warning500: '#F79009',
  warning600: '#DC6803',
  warning700: '#B54708',
  warning800: '#93370D',
  warning900: '#7A2E0E',
  warning950: '#4E1D09',
  /** Success */
  success25: '#F6FEF9',
  success50: '#ECFDF3',
  success100: '#DCFAE6',
  success200: '#ABEFC6',
  success300: '#75E0A7',
  success400: '#47CD89',
  success500: '#17B26A',
  success600: '#079455',
  success700: '#067647',
  success800: '#085D3A',
  success900: '#074D31',
  success950: '#053321',
  /** GrayBlue */
  grayBlue25: '#FCFCFD',
  grayBlue50: '#F8F9FC',
  grayBlue100: '#EAECF5',
  grayBlue200: '#D5D9EB',
  grayBlue300: '#B3B8DB',
  grayBlue400: '#717BBC',
  grayBlue500: '#4E5BA6',
  grayBlue600: '#3E4784',
  grayBlue700: '#363F72',
  grayBlue800: '#293056',
  grayBlue900: '#101323',
  grayBlue950: '#0D0F1C',
  /** GrayCool */
  grayCool25: '#FCFCFD',
  grayCool50: '#F9F9FB',
  grayCool100: '#EFF1F5',
  grayCool200: '#DCDFEA',
  grayCool300: '#B9C0D4',
  grayCool400: '#7D89B0',
  grayCool500: '#5D6B98',
  grayCool600: '#4A5578',
  grayCool700: '#404968',
  grayCool800: '#30374F',
  grayCool900: '#111322',
  grayCool950: '#0E101B',
  /**GrayModern */
  grayModern25: '#FCFCFD',
  grayModern50: '#F8FAFC',
  grayModern100: '#EEF2F6',
  grayModern200: '#E3E8EF',
  grayModern300: '#CDD5DF',
  grayModern400: '#89929E',
  grayModern500: '#697586',
  grayModern600: '#4B5565',
  grayModern700: '#364152',
  grayModern800: '#202939',
  grayModern900: '#121926',
  grayModern950: '#0D121C',
  /** GrayNeutral */
  grayNeutral25: '#FCFCFD',
  grayNeutral50: '#F9FAFB',
  grayNeutral100: '#F3F4F6',
  grayNeutral200: '#E5E7EB',
  grayNeutral300: '#D2D6DB',
  grayNeutral400: '#9DA4AE',
  grayNeutral500: '#6C737F',
  grayNeutral600: '#4D5761',
  grayNeutral700: '#384250',
  grayNeutral800: '#1F2A37',
  grayNeutral900: '#111927',
  grayNeutral950: '#0D121C',
  /** GrayIron */
  grayIron25: '#FCFCFC',
  grayIron50: '#FAFAFA',
  grayIron100: '#F4F4F5',
  grayIron200: '#E4E4E7',
  grayIron300: '#D1D1D6',
  grayIron400: '#A0A0AB',
  grayIron500: '#70707B',
  grayIron600: '#51525C',
  grayIron700: '#3F3F46',
  grayIron800: '#26272B',
  grayIron900: '#18181B',
  grayIron950: '#131316',
  /** GrayTrue */
  grayTrue25: '#FCFCFC',
  grayTrue50: '#FAFAFA',
  grayTrue100: '#F5F5F5',
  grayTrue200: '#E5E5E5',
  grayTrue300: '#D6D6D6',
  grayTrue400: '#A3A3A3',
  grayTrue500: '#737373',
  grayTrue600: '#525252',
  grayTrue700: '#424242',
  grayTrue800: '#292929',
  grayTrue900: '#141414',
  grayTrue950: '#0F0F0F',
  /** GrayWarm */
  grayWarm25: '#FDFDFC',
  grayWarm50: '#FAFAF9',
  grayWarm100: '#F5F5F4',
  grayWarm200: '#E7E5E4',
  grayWarm300: '#D7D3D0',
  grayWarm400: '#A9A29D',
  grayWarm500: '#79716B',
  grayWarm600: '#57534E',
  grayWarm700: '#44403C',
  grayWarm800: '#292524',
  grayWarm900: '#1C1917',
  grayWarm950: '#171412',
  /** Moss */
  moss25: '#FAFDF7',
  moss50: '#F5FBEE',
  moss100: '#E6F4D7',
  moss200: '#CEEAB0',
  moss300: '#ACDC79',
  moss400: '#86CB3C',
  moss500: '#669F2A',
  moss600: '#4F7A21',
  moss700: '#3F621A',
  moss800: '#335015',
  moss900: '#2B4212',
  moss950: '#1A280B',
  /** GreenLight */
  greenLight25: '#FAFEF5',
  greenLight50: '#F3FEE7',
  greenLight100: '#E4FBCC',
  greenLight200: '#D0F8AB',
  greenLight300: '#A6EF67',
  greenLight400: '#85E13A',
  greenLight500: '#66C61C',
  greenLight600: '#4CA30D',
  greenLight700: '#3B7C0F',
  greenLight800: '#326212',
  greenLight900: '#2B5314',
  greenLight950: '#15290A',
  /** Green */
  green25: '#F6FEF9',
  green50: '#EDFCF2',
  green100: '#D3F8DF',
  green200: '#AAF0C4',
  green300: '#73E2A3',
  green400: '#3CCB7F',
  green500: '#16B364',
  green600: '#099250',
  green700: '#087443',
  green800: '#095C37',
  green900: '#084C2E',
  green950: '#052E1C',
  /** Teal */
  teal25: '#F6FEFC',
  teal50: '#F0FDF9',
  teal100: '#CCFBEF',
  teal200: '#99F6E0',
  teal300: '#5FE9D0',
  teal400: '#2ED3B7',
  teal500: '#15B79E',
  teal600: '#0E9384',
  teal700: '#107569',
  teal800: '#125D56',
  teal900: '#134E48',
  teal950: '#0A2926',
  /** Cyan */
  cyan25: '#F5FEFF',
  cyan50: '#ECFDFF',
  cyan100: '#CFF9FE',
  cyan200: '#A5F0FC',
  cyan300: '#67E3F9',
  cyan400: '#22CCEE',
  cyan500: '#06AED4',
  cyan600: '#088AB2',
  cyan700: '#0E7090',
  cyan800: '#155B75',
  cyan900: '#164C63',
  cyan950: '#0D2D3A',
  /** BlueLight */
  blueLight25: '#F5FBFF',
  blueLight50: '#F0F9FF',
  blueLight100: '#E0F2FE',
  blueLight200: '#B9E6FE',
  blueLight300: '#7CD4FD',
  blueLight400: '#36BFFA',
  blueLight500: '#0BA5EC',
  blueLight600: '#0086C9',
  blueLight700: '#026AA2',
  blueLight800: '#065986',
  blueLight900: '#0B4A6F',
  blueLight950: '#062C41',
  /** Blue */
  blue25: '#F5FAFF',
  blue50: '#EFF8FF',
  blue100: '#D1E9FF',
  blue200: '#B2DDFF',
  blue300: '#84CAFF',
  blue400: '#53B1FD',
  blue500: '#2E90FA',
  blue600: '#1570EF',
  blue700: '#175CD3',
  blue800: '#1849A9',
  blue900: '#194185',
  blue950: '#102A56',
  /** BlueDark */
  blueDark25: '#F5F8FF',
  blueDark50: '#EFF4FF',
  blueDark100: '#D1E0FF',
  blueDark200: '#B2CCFF',
  blueDark300: '#84ADFF',
  blueDark400: '#528BFF',
  blueDark500: '#2970FF',
  blueDark600: '#155EEF',
  blueDark700: '#004EEB',
  blueDark800: '#0040C1',
  blueDark900: '#00359E',
  blueDark950: '#002266',
  /** Indigo */
  indigo25: '#F5F8FF',
  indigo50: '#EEF4FF',
  indigo100: '#E0EAFF',
  indigo200: '#C7D7FE',
  indigo300: '#A4BCFD',
  indigo400: '#8098F9',
  indigo500: '#6172F3',
  indigo600: '#444CE7',
  indigo700: '#3538CD',
  indigo800: '#2D31A6',
  indigo900: '#2D3282',
  indigo950: '#1F235B',
  /** Violet */
  violet25: '#FBFAFF',
  violet50: '#F5F3FF',
  violet100: '#ECE9FE',
  violet200: '#DDD6FE',
  violet300: '#C3B5FD',
  violet400: '#A48AFB',
  violet500: '#875BF7',
  violet600: '#7839EE',
  violet700: '#6927DA',
  violet800: '#5720B7',
  violet900: '#491C96',
  violet950: '#2E125E',
  /** Purple */
  purple25: '#FAFAFF',
  purple50: '#F4F3FF',
  purple100: '#EBE9FE',
  purple200: '#D9D6FE',
  purple300: '#BDB4FE',
  purple400: '#9B8AFB',
  purple500: '#7A5AF8',
  purple600: '#6938EF',
  purple700: '#5925DC',
  purple800: '#4A1FB8',
  purple900: '#3E1C96',
  purple950: '#27115F',
  /** Fuchsia */
  fuchsia25: '#FEFAFF',
  fuchsia50: '#FDF4FF',
  fuchsia100: '#FBE8FF',
  fuchsia200: '#F6D0FE',
  fuchsia300: '#EEAAFD',
  fuchsia400: '#E478FA',
  fuchsia500: '#D444F1',
  fuchsia600: '#BA24D5',
  fuchsia700: '#9F1AB1',
  fuchsia800: '#821890',
  fuchsia900: '#6F1877',
  fuchsia950: '#47104C',
  /** Pink */
  pink25: '#FEF6FB',
  pink50: '#FDF2FA',
  pink100: '#FCE7F6',
  pink200: '#FCCEEE',
  pink300: '#FAA7E0',
  pink400: '#F670C7',
  pink500: '#EE46BC',
  pink600: '#DD2590',
  pink700: '#C11574',
  pink800: '#9E165F',
  pink900: '#851651',
  pink950: '#4E0D30',
  /** Rose */
  rose25: '#FFF5F6',
  rose50: '#FFF1F3',
  rose100: '#FFE4E8',
  rose200: '#FECDD6',
  rose300: '#FEA3B4',
  rose400: '#FD6F8E',
  rose500: '#F63D68',
  rose600: '#E31B54',
  rose700: '#C01048',
  rose800: '#A11043',
  rose900: '#89123E',
  rose950: '#510B24',
  /** OrangeDark */
  orangeDark25: '#FFF9F5',
  orangeDark50: '#FFF4ED',
  orangeDark100: '#FFE6D5',
  orangeDark200: '#FFD6AE',
  orangeDark300: '#FF9C66',
  orangeDark400: '#FF692E',
  orangeDark500: '#FF4405',
  orangeDark600: '#E62E05',
  orangeDark700: '#BC1B06',
  orangeDark800: '#97180C',
  orangeDark900: '#771A0D',
  orangeDark950: '#57130A',
  /** Orange */
  orange25: '#FEFAF5',
  orange50: '#FEF6EE',
  orange100: '#FDEAD7',
  orange200: '#F9DBAF',
  orange300: '#F7B27A',
  orange400: '#F38744',
  orange500: '#EF6820',
  orange600: '#E04F16',
  orange700: '#B93815',
  orange800: '#932F19',
  orange900: '#772917',
  orange950: '#511C10',
  /** Yellow */
  yellow25: '#FEFDF0',
  yellow50: '#FEFBE8',
  yellow100: '#FEF7C3',
  yellow200: '#FEEE95',
  yellow300: '#FDE272',
  yellow400: '#FAC515',
  yellow500: '#EAAA08',
  yellow600: '#CA8504',
  yellow700: '#A15C07',
  yellow800: '#854A0E',
  yellow900: '#713B12',
  yellow950: '#542C0D'
};